<template>
    <div class="m-content">
        <audio class="w-full" controls preload="none">
            <source :src="getMediaUrl()" type="audio/ogg" @error="onError()">
        </audio>
    </div>
</template>

<script>
    import {Zapin} from "@/services/Api";

    export default {
        props: {
            message: Object,
            instanceId: String
        },

        inject: ['alert'],

        methods: {
            getMediaUrl() {
                return Zapin.media().mountLoadUrl(this.instanceId, this.message.id, this.message.quoted);
            },

            onError() {
                this.alert.show(this.$t('this_media_is_not_available'));
            }
        }
    }
</script>
